<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  
  <!-- Loading indicator -->
  @if (loadingAccounts) {
<div class="loading-spinner">
    <i class="fa fa-spinner fa-pulse"></i>
  </div>
}

  <!-- Entity Details (commented out in original, but structure preserved) -->
  <!-- Original had entity details commented out - keeping structure for reference -->
  
  <!-- Form Container -->
  @if (!loadingAccounts) {
<div>
    <form name="batchPayorForm" id="batchPayorForm" novalidate autocomplete="off">
      
      <!-- Case: ALL payment type selected -->
      @if (payment_type == 'ALL') {
<div class="centerText">
        <h4>Please select single Category in Grid Filters to allocate Payor..</h4>
      </div>
}

      <!-- Current Issue ID (for Qualified Amended Returns) -->
      @if (globalScenarioDesc === 'Qualified Amended Returns') {
<div class="row-container issue-id-row">
        <div class="col-50"></div>
        <div class="col-50 LayerLine1">
          <label>Current Issue ID: </label>
          <label>{{glbl_issue_id}}</label>
        </div>
      </div>
}

      <!-- ====================================================================== -->
      <!-- M_ADJUSTMENT (Tax Adjustment) Views                                  -->
      <!-- ====================================================================== -->
      @if (trans_type == 'M_ADJUSTMENT') {
<div>
        @for (entity of entityData; track $index; let mainIndex = $index) {
<div>
          
          <!-- Entity Header Row -->
          @if (payment_type != 'ALL') {
<div class="row-container entity-header-row">
            @if (entity.T_SCENARIO_TYPE_CODE != 'EXAM') {
<div class="col-spacer"></div>
}
            <div class="col-entity-info LayerData1">
              <label>Entity Tax: </label>
              <label>{{entity.LEID}}</label>
            </div>
            <div class="col-entity-info LayerData1">
              <label>Tax Code: </label>
              <label>{{entity.CDR_NO}}</label>
            </div>
            <div class="col-entity-info LayerData1">
              <label>ME Code: </label>
              <label>{{entity.ME_CODE}}</label>
            </div>
            <div class="col-entity-info LayerData1">
              <label>Reporting Period: </label>
              <label>{{entity.REP_PD}}</label>
            </div>
            <div class="col-entity-info LayerData1">
              <label>Ledger: </label>
              <label>{{entity.LEDGER}}</label>
            </div>
            @if (entity.T_SCENARIO_TYPE_CODE === 'EXAM') {
<div class="col-entity-info LayerData1">
              <label>Issue ID: </label>
              <label>{{entity.ISSUE_ID}}</label>
            </div>
}
            @if (entity.T_SCENARIO_TYPE_CODE != 'EXAM') {
<div class="col-spacer"></div>
}
          </div>
}

          <!-- ====================================================================== -->
          <!-- INTEREST Payment Type (Tax Adjustment)                                -->
          <!-- ====================================================================== -->
          @if (payment_type == 'INTEREST') {
<div>
            <!-- Table Header -->
            <div class="row-container table-header-row">
              <hr>
              <div class="col-icon"></div>
              <div class="col-account-md centerText"><label>Account</label></div>
              <div class="col-tp-md centerText"><label>Trading Partner</label></div>
              <div class="col-empty-md centerText"><label></label></div>
              <div class="col-amount-sm centerText"><label>Amount</label></div>
            </div>
            
            <!-- Data Rows -->
            @for (account of entity.Account_data; track $index; let acctIndex = $index) {
<div>
              <hr>
              @for (sub_acct of account.sub_acct_data; track $index; let subIndex = $index) {
<div 
                   class="row-container data-row">
                
                <div class="col-icon"></div>

                <!-- Account -->
                <div class="col-account-md centerText">
                  <input type="text" name="payorAccount" readonly class="form-control input-sm" 
                         [value]="sub_acct.FROM_ACCT + ' - ' + sub_acct.FROM_ACCT_DESC + ' - ' + sub_acct.SCHDM_TEMPLATE_KEY + ' - ' + sub_acct.ADJ_ORIGIN_SOURCE">
                </div>

                <!-- Trading Partner (TB - Trial Balance) -->
                @if (sub_acct.ROW_TYPE == 'TB') {
<div class="col-tp-md centerText">
                  <select class="form-control input-sm" disabled 
                          [(ngModel)]="sub_acct.TP_DETAILS" 
                          [name]="'payorID_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                    @for (tp of sub_acct.tp_dropdown_data; track $index) {
<option [ngValue]="tp">
                      {{tp.TP_ENTITY}}
                    </option>
}
                  </select>
                </div>
}

                <!-- Trading Partner (EX - Existing) -->
                @if (sub_acct.ROW_TYPE == 'EX') {
<div class="col-tp-md centerText">
                  <select class="form-control input-sm" 
                          [(ngModel)]="sub_acct.TP_DETAILS"
                          (ngModelChange)="updatingPayor(mainIndex, acctIndex, subIndex, sub_acct.TP_DETAILS)"
                          [name]="'payorID_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                    @for (tp of sub_acct.tp_dropdown_data; track $index) {
<option [ngValue]="tp">
                      {{tp.TP_ENTITY}}
                    </option>
}
                  </select>
                </div>
}

                <!-- Empty column -->
                <div class="col-empty-md centerText"></div>

                <!-- Amount -->
                <div class="col-amount-sm noWrap numText">
                  <div class="input-group">
                    <input type="text" readonly 
                           class="form-control input-sm numText" 
                           [value]="sub_acct.ALLOCATED_AMT | number:'1.0-0'"
                           [name]="'intAmt_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                  </div>
                </div>
              </div>
}
            </div>
}
          </div>
}

          <!-- ====================================================================== -->
          <!-- M3PAYOR Payment Type (Tax Adjustment)                                 -->
          <!-- ====================================================================== -->
          @if (payment_type == 'M3PAYOR') {
<div>
            <!-- Table Header -->
            <div class="row-container table-header-row">
              <hr>
              <div class="col-icon"></div>
              <div class="col-account-sm centerText"><label>Account</label></div>
              <div class="col-tp-sm centerText"><label>Trading Partner</label></div>
              <div class="col-amount-sm centerText"><label>Amount</label></div>
              <div class="col-payor-type centerText"><label>Payor Type</label></div>
              <div class="col-payor-name centerText"><label>Payor Name</label></div>
              <div class="col-icon"></div>
            </div>
            
            <!-- Data Rows -->
            @for (account of entity.Account_data; track $index; let acctIndex = $index) {
<div>
              <hr>
              @for (sub_acct of account.sub_acct_data; track $index; let subIndex = $index) {
<div 
                   class="row-container data-row">
                
                <div class="col-icon"></div>

                <!-- Account -->
                <div class="col-account-sm centerText">
                  <input type="text" name="payorAccount" readonly class="form-control input-sm" 
                         [value]="sub_acct.FROM_ACCT + ' - ' + sub_acct.FROM_ACCT_DESC + ' - ' + sub_acct.SCHDM_TEMPLATE_KEY + ' - ' + sub_acct.ADJ_ORIGIN_SOURCE">
                </div>

                <!-- Trading Partner (TB) -->
                @if (sub_acct.ROW_TYPE == 'TB') {
<div class="col-tp-sm centerText">
                  <select class="form-control input-sm" disabled 
                          [(ngModel)]="sub_acct.TP_DETAILS"
                          [name]="'payorID_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                    @for (tp of sub_acct.tp_dropdown_data; track $index) {
<option [ngValue]="tp">
                      {{tp.TP_ENTITY}}
                    </option>
}
                  </select>
                </div>
}

                <!-- Trading Partner (EX) - Typeahead search -->
                @if (sub_acct.ROW_TYPE == 'EX') {
<div class="col-tp-sm centerText">
                  <div class="input-group">
                    <input type="text" 
                           class="form-control input-sm" 
                           placeholder="begin typing to select trading partner"
                           [(ngModel)]="sub_acct.TP_DETAILS"
                           [name]="'tradingPartner_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                    <span class="input-group-addon">
                      <i [ngClass]="loadingTPs ? 'fa fa-spinner fa-pulse' : 'fa fa-search'"></i>
                    </span>
                  </div>
                </div>
}

                <!-- Amount -->
                <div class="col-amount-sm noWrap numText">
                  <div class="centerText">
                    <input type="text" readonly 
                           class="form-control input-sm numText" 
                           [value]="sub_acct.ALLOCATED_AMT | number:'1.0-0'"
                           [name]="'intAmtOther_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                  </div>
                </div>

                <!-- Payor Type (for IS_OTHER_PAYOR) -->
                @if (sub_acct.ROW_TYPE == 'EX' && sub_acct.LINE == '1' && sub_acct.IS_OTHER_PAYOR == 'Y') {
<div class="col-payor-type centerText" 
                    >
                  <select class="form-control input-sm"
                          [(ngModel)]="sub_acct.PAYOR_TYPE"
                          (ngModelChange)="setPayorType(sub_acct.PAYOR_TYPE, mainIndex, acctIndex, subIndex)"
                          [name]="'payorType_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                    @for (type of M3_Payor_types; track $index) {
<option [ngValue]="type.PAYOR_TYPE">
                      {{type.PAYOR_TYPE}}
                    </option>
}
                  </select>
                  @if (sub_acct.HAS_TYPE_ERROR === 'Y') {
<span class="form-error-container">
                    {{sub_acct.PAYOR_TYPE_ERROR}}
                  </span>
}
                </div>
}

                <!-- Payor Name -->
                @if (sub_acct.ROW_TYPE == 'EX' && sub_acct.LINE == '1' && sub_acct.IS_OTHER_PAYOR == 'Y') {
<div class="col-payor-name centerText" 
                    >
                  <input type="text" name="payor_name" maxlength="6" 
                         class="form-control input-sm" 
                         [(ngModel)]="sub_acct.PAYOR_NAME"
                         (ngModelChange)="updatedDetails(mainIndex, acctIndex, subIndex)">
                </div>
}

                <div class="col-icon"></div>
              </div>
}
            </div>
}
          </div>
}

          <!-- ====================================================================== -->
          <!-- OTHER Payment Types (Tax Adjustment)                                  -->
          <!-- ====================================================================== -->
          @if (payment_type != 'INTEREST' && payment_type != 'M3PAYOR' && payment_type != 'ALL') {
<div>
            <!-- Table Header -->
            <div class="row-container table-header-row">
              <hr>
              <div class="col-icon"></div>
              <div class="col-account-lg centerText"><label>Account</label></div>
              <div class="col-tp-lg centerText"><label>Trading Partner</label></div>
              <div class="col-amount-md centerText"><label>Amount</label></div>
            </div>
            
            <!-- Data Rows -->
            @for (account of entity.Account_data; track $index; let acctIndex = $index) {
<div>
              <hr>
              @for (sub_acct of account.sub_acct_data; track $index; let subIndex = $index) {
<div 
                   class="row-container data-row">
                
                <div class="col-icon"></div>

                <!-- Account -->
                <div class="col-account-lg centerText">
                  <input type="text" name="payorAccount" readonly class="form-control input-sm" 
                         [value]="sub_acct.FROM_ACCT + ' - ' + sub_acct.FROM_ACCT_DESC + ' - ' + sub_acct.SCHDM_TEMPLATE_KEY + ' - ' + sub_acct.ADJ_ORIGIN_SOURCE">
                </div>

                <!-- Trading Partner (TB) -->
                @if (sub_acct.ROW_TYPE == 'TB') {
<div class="col-tp-lg centerText">
                  <select class="form-control input-sm" disabled 
                          [(ngModel)]="sub_acct.TP_DETAILS"
                          [name]="'payorID_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                    @for (tp of sub_acct.tp_dropdown_data; track $index) {
<option [ngValue]="tp">
                      {{tp.TP_ENTITY}}
                    </option>
}
                  </select>
                </div>
}

                <!-- Trading Partner (EX) -->
                @if (sub_acct.ROW_TYPE == 'EX') {
<div class="col-tp-lg centerText">
                  <select class="form-control input-sm" 
                          [(ngModel)]="sub_acct.TP_DETAILS"
                          (ngModelChange)="updatingPayor(mainIndex, acctIndex, subIndex, sub_acct.TP_DETAILS)"
                          [name]="'payorID_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                    @for (tp of sub_acct.tp_dropdown_data; track $index) {
<option [ngValue]="tp">
                      {{tp.TP_ENTITY}}
                    </option>
}
                  </select>
                </div>
}

                <!-- Amount -->
                <div class="col-amount-md noWrap numText">
                  <div class="input-group">
                    <input type="text" readonly 
                           class="form-control input-sm numText" 
                           [value]="sub_acct.ALLOCATED_AMT | number:'1.0-0'"
                           [name]="'adjAmtMadj_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                  </div>
                </div>
              </div>
}
            </div>
}
          </div>
}

        </div>
}
      </div>
}

      <!-- ====================================================================== -->
      <!-- BOOK_AMT Views                                                        -->
      <!-- ====================================================================== -->
      @if (trans_type == 'BOOK_AMT') {
<div>
        @for (entity of entityData; track $index; let mainIndex = $index) {
<div>
          
          <!-- Entity Header Row -->
          @if (payment_type != 'ALL') {
<div class="row-container entity-header-row">
            @if (entity.T_SCENARIO_TYPE_CODE != 'EXAM') {
<div class="col-spacer"></div>
}
            <div class="col-entity-info LayerData1">
              <label>Entity Book: </label>
              <label>{{entity.LEID}}</label>
            </div>
            <div class="col-entity-info LayerData1">
              <label>Tax Code: </label>
              <label>{{entity.CDR_NO}}</label>
            </div>
            <div class="col-entity-info LayerData1">
              <label>ME Code: </label>
              <label>{{entity.ME_CODE}}</label>
            </div>
            <div class="col-entity-info LayerData1">
              <label>Reporting Period: </label>
              <label>{{entity.REP_PD}}</label>
            </div>
            <div class="col-entity-info LayerData1">
              <label>Ledger: </label>
              <label>{{entity.LEDGER}}</label>
            </div>
            @if (entity.T_SCENARIO_TYPE_CODE === 'EXAM') {
<div class="col-entity-info LayerData1">
              <label>Issue ID: </label>
              <label>{{entity.ISSUE_ID}}</label>
            </div>
}
            @if (entity.T_SCENARIO_TYPE_CODE != 'EXAM') {
<div class="col-spacer"></div>
}
          </div>
}

          <!-- ====================================================================== -->
          <!-- Non-INTEREST, Non-M3PAYOR (Book Amount)                               -->
          <!-- ====================================================================== -->
          @if (payment_type != 'INTEREST' && payment_type != 'M3PAYOR' && payment_type != 'ALL') {
<div>
            <!-- Table Header -->
            <div class="row-container table-header-row">
              <hr>
              <div class="col-icon"></div>
              <div class="col-icon"></div>
              <div class="col-account-md centerText"><label>Account</label></div>
              <div class="col-tp-sm centerText"><label>Trading Partner</label></div>
              <div class="col-empty-sm centerText"><label></label></div>
              <div class="col-amount-md centerText"><label>Adj Amt</label></div>
            </div>
            
            <!-- Data Rows -->
            @for (account of entity.Account_data; track $index; let acctIndex = $index) {
<div>
              <hr>
              @for (sub_acct of account.sub_acct_data; track $index; let subIndex = $index) {
<div 
                   class="row-container data-row">
                
                <div class="col-icon"></div>

                <!-- Add/Remove Buttons -->
                @if (sub_acct.ROW_TYPE == 'TB') {
<div class="col-icon gt-edit-col"></div>
}
                @if (sub_acct.ROW_TYPE == 'HEADER_ROW' && checkEditScenario(sub_acct.T_SCENARIO_TYPE_CODE, sub_acct.T_SCENARIO, sub_acct.ISSUE_ID)) {
<div class="col-icon gt-edit-col" 
                    >
                  <i (click)="addNewPayor(mainIndex, acctIndex, subIndex)" 
                     class="fa fa-plus-circle color-green pointer"
                     title="Add New Payor"></i>
                </div>
}
                @if ((sub_acct.ROW_TYPE == 'NEW' || sub_acct.ROW_TYPE == 'EX') && checkEditScenario(sub_acct.T_SCENARIO_TYPE_CODE, sub_acct.T_SCENARIO, sub_acct.ISSUE_ID)) {
<div class="col-icon gt-edit-col" 
                    >
                  <i (click)="removePayor(mainIndex, acctIndex, subIndex)" 
                     class="fa fa-minus-circle color-red pointer"
                     title="Remove This Payor"></i>
                </div>
}

                <!-- Account (HEADER_ROW) -->
                @if (sub_acct.ROW_TYPE == 'HEADER_ROW') {
<div class="col-account-md centerText">
                  <label>{{sub_acct.FROM_ACCT}} - {{sub_acct.FROM_ACCT_DESC}}</label>
                </div>
}

                <!-- Account (Other rows) -->
                @if (sub_acct.ROW_TYPE != 'HEADER_ROW') {
<div class="col-account-md centerText">
                  <input type="text" name="payorAccount" readonly class="form-control input-sm" 
                         [value]="sub_acct.FROM_ACCT + ' - ' + sub_acct.FROM_ACCT_DESC">
                </div>
}

                <!-- Book Amt (HEADER_ROW) -->
                @if (sub_acct.ROW_TYPE == 'HEADER_ROW') {
<div class="col-tp-sm centerText">
                  <label>Book Amt: </label>
                  <span>{{sub_acct.BOOK_AMT | number:'1.0-0'}}</span>
                </div>
}

                <!-- Trading Partner (TB) - show as readonly input since TP_DETAILS is a string from API -->
                @if (sub_acct.ROW_TYPE == 'TB') {
<div class="col-tp-sm centerText">
                  <input type="text" readonly class="form-control input-sm"
                         [value]="sub_acct.TP_DETAILS || ''"
                         [name]="'payorID_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                </div>
}

                <!-- Trading Partner (EX) - show as readonly input since TP_DETAILS is a string from API -->
                @if (sub_acct.ROW_TYPE == 'EX') {
<div class="col-tp-sm centerText">
                  <input type="text" readonly class="form-control input-sm"
                         [value]="sub_acct.TP_DETAILS || ''"
                         [name]="'payorIDex_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                </div>
}

                <!-- Trading Partner (NEW) - Autocomplete search (min 3 chars, 300ms debounce) -->
                @if (sub_acct.ROW_TYPE == 'NEW') {
<div class="col-tp-sm centerText">
                  <div class="input-group">
                    <input type="text" 
                           class="form-control input-sm" 
                           placeholder="begin typing to select trading partner"
                           [(ngModel)]="sub_acct.TP_DETAILS"
                           (input)="onAutocompleteInput($any($event.target).value, mainIndex, acctIndex, subIndex)"
                           [matAutocomplete]="auto"
                           [name]="'tradingPartner_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                    <mat-autocomplete #auto="matAutocomplete" 
                                      [displayWith]="displayTradingPartner.bind(this)"
                                      (optionSelected)="onAutocompleteSelected($event.option.value, mainIndex, acctIndex, subIndex)">
                      @for (tp of filteredTradingPartners[mainIndex + '_' + acctIndex + '_' + subIndex] | async; track $index) {
<mat-option 
                                  [value]="tp">
                        {{tp.TP_ENTITY}}
                      </mat-option>
}
                    </mat-autocomplete>
                    <span class="input-group-addon">
                      <i [ngClass]="loadingTPs ? 'fa fa-spinner fa-pulse' : 'fa fa-search'"></i>
                    </span>
                  </div>
                  @if (sub_acct.HAS_ERROR === 'Y') {
<span class="form-error-container">
                    {{sub_acct.TP_ERROR}}
                  </span>
}
                </div>
}

                <!-- Allocated Amt (HEADER_ROW) -->
                @if (sub_acct.ROW_TYPE == 'HEADER_ROW') {
<div class="col-empty-sm centerText">
                  <label>Allocated Amt: </label>
                  <span>{{sub_acct.TOTAL_ALLOCATED_AMT | number:'1.0-0'}}</span>
                </div>
}

                <!-- Unallocated Amt (HEADER_ROW) -->
                @if (sub_acct.ROW_TYPE == 'HEADER_ROW') {
<div class="col-amount-md centerText">
                  <label>Unallocated Amt: </label>
                  <span>{{sub_acct.UNALLOCATED_AMT | number:'1.0-0'}}</span>
                </div>
}

                <!-- Adj Amt (TB) -->
                @if (sub_acct.ROW_TYPE == 'TB') {
<div class="col-amount-md centerText">
                  <div class="centerText">
                    <input type="text" readonly 
                           class="form-control input-sm numText" 
                           [value]="sub_acct.ALLOCATED_AMT | number:'1.0-0'"
                           [name]="'adjAmt_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                  </div>
                </div>
}

                <!-- Adj Amt (EX) -->
                @if (sub_acct.ROW_TYPE == 'EX') {
<div class="col-amount-md centerText">
                  <div class="centerText">
                    <input type="text" readonly 
                           class="form-control input-sm numText" 
                           [value]="sub_acct.ALLOCATED_AMT | number:'1.0-0'"
                           [name]="'adjAmtEx_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                  </div>
                </div>
}

                <!-- Adj Amt (NEW) - editable -->
                @if (sub_acct.ROW_TYPE == 'NEW') {
<div class="col-amount-md centerText">
                  <div class="centerText">
                    <input type="text" required 
                           class="form-control input-sm numText" 
                           [(ngModel)]="sub_acct.ALLOCATED_AMT"
                           [name]="'adjAmtNew_' + mainIndex + '_' + acctIndex + '_' + subIndex"
                           (blur)="updateAmount(mainIndex, acctIndex, subIndex, 'I')">
                  </div>
                </div>
}
              </div>
}
            </div>
}
          </div>
}

          <!-- ====================================================================== -->
          <!-- M3PAYOR (Book Amount)                                                 -->
          <!-- ====================================================================== -->
          @if (payment_type == 'M3PAYOR') {
<div>
            <!-- Table Header -->
            <div class="row-container table-header-row">
              <hr>
              <div class="col-icon"></div>
              <div class="col-icon"></div>
              <div class="col-account-sm centerText"><label>Account</label></div>
              <div class="col-tp-sm centerText"><label>Trading Partner</label></div>
              <div class="col-amount-sm centerText"><label>Amount</label></div>
              <div class="col-payor-type centerText"><label>Payor Type</label></div>
              <div class="col-payor-name centerText"><label>Payor Name</label></div>
            </div>
            
            <!-- Data Rows -->
            @for (account of entity.Account_data; track $index; let acctIndex = $index) {
<div>
              <hr>
              @for (sub_acct of account.sub_acct_data; track $index; let subIndex = $index) {
<div 
                   class="row-container data-row">
                
                <div class="col-icon"></div>

                <!-- Add/Remove Buttons -->
                @if (sub_acct.ROW_TYPE == 'TB') {
<div class="col-icon gt-edit-col"></div>
}
                @if (sub_acct.ROW_TYPE == 'HEADER_ROW' && checkEditScenario(sub_acct.T_SCENARIO_TYPE_CODE, sub_acct.T_SCENARIO, sub_acct.ISSUE_ID)) {
<div class="col-icon gt-edit-col" 
                    >
                  <i (click)="addNewPayor(mainIndex, acctIndex, subIndex)" 
                     class="fa fa-plus-circle color-green pointer"
                     title="Add New Payor"></i>
                </div>
}
                @if ((sub_acct.ROW_TYPE == 'NEW' || sub_acct.ROW_TYPE == 'EX') && checkEditScenario(sub_acct.T_SCENARIO_TYPE_CODE, sub_acct.T_SCENARIO, sub_acct.ISSUE_ID)) {
<div class="col-icon gt-edit-col" 
                    >
                  <i (click)="removePayor(mainIndex, acctIndex, subIndex)" 
                     class="fa fa-minus-circle color-red pointer"
                     title="Remove This Payor"></i>
                </div>
}

                <!-- Account (HEADER_ROW) -->
                @if (sub_acct.ROW_TYPE == 'HEADER_ROW') {
<div class="col-account-sm centerText">
                  <label>{{sub_acct.FROM_ACCT}} - {{sub_acct.FROM_ACCT_DESC}}</label>
                </div>
}

                <!-- Account (Other rows) -->
                @if (sub_acct.ROW_TYPE != 'HEADER_ROW') {
<div class="col-account-sm centerText">
                  <input type="text" name="payorAccount" readonly class="form-control input-sm" 
                         [value]="sub_acct.FROM_ACCT + ' - ' + sub_acct.FROM_ACCT_DESC">
                </div>
}

                <!-- Book Amt / Trading Partner columns follow similar pattern as above -->
                <!-- (Continuing with similar structure for M3PAYOR book amount view) -->
                
                <!-- ... Additional M3PAYOR Book Amount fields ... -->
                
              </div>
}
            </div>
}
          </div>
}

          <!-- ====================================================================== -->
          <!-- INTEREST (Book Amount)                                                -->
          <!-- ====================================================================== -->
          @if (payment_type == 'INTEREST') {
<div>
            <!-- Similar structure as above for Interest Book Amount view -->
            <!-- Table Header -->
            <div class="row-container table-header-row">
              <hr>
              <div class="col-icon"></div>
              <div class="col-icon"></div>
              <div class="col-account-md centerText"><label>Account</label></div>
              <div class="col-tp-sm centerText"><label>Trading Partner</label></div>
              <div class="col-empty-sm centerText"><label></label></div>
              <div class="col-amount-md centerText"><label>Adj Amt</label></div>
            </div>

            <!-- Data Rows -->
            @for (account of entity.Account_data; track $index; let acctIndex = $index) {
<div>
              <hr>
              @for (sub_acct of account.sub_acct_data; track $index; let subIndex = $index) {
<div
                   class="row-container data-row">

                <div class="col-icon"></div>

                <!-- Add/Remove Buttons -->
                @if (sub_acct.ROW_TYPE == 'TB') {
<div class="col-icon gt-edit-col"></div>
}
                @if (sub_acct.ROW_TYPE == 'HEADER_ROW' && checkEditScenario(sub_acct.T_SCENARIO_TYPE_CODE, sub_acct.T_SCENARIO, sub_acct.ISSUE_ID)) {
<div class="col-icon gt-edit-col"
                    >
                  <i (click)="addNewPayor(mainIndex, acctIndex, subIndex)"
                     class="fa fa-plus-circle color-green pointer"
                     title="Add New Payor"></i>
                </div>
}
                @if ((sub_acct.ROW_TYPE == 'NEW' || sub_acct.ROW_TYPE == 'EX') && checkEditScenario(sub_acct.T_SCENARIO_TYPE_CODE, sub_acct.T_SCENARIO, sub_acct.ISSUE_ID)) {
<div class="col-icon gt-edit-col"
                    >
                  <i (click)="removePayor(mainIndex, acctIndex, subIndex)"
                     class="fa fa-minus-circle color-red pointer"
                     title="Remove This Payor"></i>
                </div>
}

                <!-- Account (HEADER_ROW) -->
                @if (sub_acct.ROW_TYPE == 'HEADER_ROW') {
<div class="col-account-md centerText">
                  <label>{{sub_acct.FROM_ACCT}} - {{sub_acct.FROM_ACCT_DESC}}</label>
                </div>
}

                <!-- Account (Other rows) -->
                @if (sub_acct.ROW_TYPE != 'HEADER_ROW') {
<div class="col-account-md centerText">
                  <input type="text" name="payorAccount" readonly class="form-control input-sm"
                         [value]="sub_acct.FROM_ACCT + ' - ' + sub_acct.FROM_ACCT_DESC">
                </div>
}

                <!-- Book Amt (HEADER_ROW) -->
                @if (sub_acct.ROW_TYPE == 'HEADER_ROW') {
<div class="col-tp-sm centerText">
                  <label>Book Amt: </label>
                  <span>{{sub_acct.BOOK_AMT | number:'1.0-0'}}</span>
                </div>
}

                <!-- Trading Partner (TB) - readonly -->
                @if (sub_acct.ROW_TYPE == 'TB') {
<div class="col-tp-sm centerText">
                  <input type="text" readonly class="form-control input-sm"
                         [value]="sub_acct.TP_DETAILS || ''"
                         [name]="'intBkPayorTb_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                </div>
}

                <!-- Trading Partner (EX) - readonly (disabled per AngularJS) -->
                @if (sub_acct.ROW_TYPE == 'EX') {
<div class="col-tp-sm centerText">
                  <input type="text" readonly class="form-control input-sm"
                         [value]="sub_acct.TP_DETAILS || ''"
                         [name]="'intBkPayorEx_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                </div>
}

                <!-- Trading Partner (NEW) - Autocomplete search -->
                @if (sub_acct.ROW_TYPE == 'NEW') {
<div class="col-tp-sm centerText">
                  <div class="input-group">
                    <input type="text"
                           class="form-control input-sm"
                           placeholder="begin typing to select trading partner"
                           [(ngModel)]="sub_acct.TP_DETAILS"
                           (input)="onAutocompleteInput($any($event.target).value, mainIndex, acctIndex, subIndex)"
                           [matAutocomplete]="autoIntBk"
                           [name]="'intBkTp_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                    <mat-autocomplete #autoIntBk="matAutocomplete"
                                      [displayWith]="displayTradingPartner.bind(this)"
                                      (optionSelected)="onAutocompleteSelected($event.option.value, mainIndex, acctIndex, subIndex)">
                      @for (tp of filteredTradingPartners[mainIndex + '_' + acctIndex + '_' + subIndex] | async; track $index) {
<mat-option
                                  [value]="tp">
                        {{tp.TP_ENTITY}}
                      </mat-option>
}
                    </mat-autocomplete>
                    <span class="input-group-addon">
                      <i [ngClass]="loadingTPs ? 'fa fa-spinner fa-pulse' : 'fa fa-search'"></i>
                    </span>
                  </div>
                  @if (sub_acct.HAS_ERROR === 'Y') {
<span class="form-error-container">
                    {{sub_acct.TP_ERROR}}
                  </span>
}
                </div>
}

                <!-- Allocated Amt (HEADER_ROW) -->
                @if (sub_acct.ROW_TYPE == 'HEADER_ROW') {
<div class="col-empty-sm centerText">
                  <label>Allocated Amt: </label>
                  <span>{{sub_acct.TOTAL_ALLOCATED_AMT | number:'1.0-0'}}</span>
                </div>
}

                <!-- Empty column for TB/EX/NEW rows (matches AngularJS layout) -->
                @if (sub_acct.ROW_TYPE != 'HEADER_ROW') {
<div class="col-empty-sm"></div>
}

                <!-- Unallocated Amt (HEADER_ROW) -->
                @if (sub_acct.ROW_TYPE == 'HEADER_ROW') {
<div class="col-amount-md centerText">
                  <label>Unallocated Amt: </label>
                  <span>{{sub_acct.UNALLOCATED_AMT | number:'1.0-0'}}</span>
                </div>
}

                <!-- Adj Amt (TB) -->
                @if (sub_acct.ROW_TYPE == 'TB') {
<div class="col-amount-md centerText">
                  <div class="centerText">
                    <input type="text" readonly
                           class="form-control input-sm numText"
                           [value]="sub_acct.ALLOCATED_AMT | number:'1.0-0'"
                           [name]="'intBkAmtTb_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                  </div>
                </div>
}

                <!-- Adj Amt (EX) -->
                @if (sub_acct.ROW_TYPE == 'EX') {
<div class="col-amount-md centerText">
                  <div class="centerText">
                    <input type="text" readonly
                           class="form-control input-sm numText"
                           [value]="sub_acct.ALLOCATED_AMT | number:'1.0-0'"
                           [name]="'intBkAmtEx_' + mainIndex + '_' + acctIndex + '_' + subIndex">
                  </div>
                </div>
}

                <!-- Adj Amt (NEW) - editable -->
                @if (sub_acct.ROW_TYPE == 'NEW') {
<div class="col-amount-md centerText">
                  <div class="centerText">
                    <input type="text" required
                           class="form-control input-sm numText"
                           [(ngModel)]="sub_acct.ALLOCATED_AMT"
                           [name]="'intBkAmtNew_' + mainIndex + '_' + acctIndex + '_' + subIndex"
                           (blur)="updateAmount(mainIndex, acctIndex, subIndex, 'I')">
                  </div>
                </div>
}

              </div>
}
            </div>
}
          </div>
}

        </div>
}
      </div>
}

    </form>
  </div>
}
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <!-- Total Allocation Process (only for INTEREST with access) -->
  @if (payment_type == 'INTEREST' && is_allocate_access) {
<button 
          class="save-button" 
          type="button" 
          (click)="allocate_payor('A')">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Total Allocation Process
  </button>
}
  
  <!-- Allocation Process (only for INTEREST with access) -->
  @if (payment_type == 'INTEREST' && is_allocate_access) {
<button 
          class="save-button" 
          type="button" 
          (click)="allocate_payor('I')">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Allocation Process
  </button>
}
  
  <!-- Save Button -->
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Save
  </button>
  
  <!-- Reset Button -->
  <button class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
  
  <!-- Cancel Button -->
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
